import BaseContainer from "@base/container/BaseContainer";
import Facade from "@/Facade";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import {Signals} from "@/Imports";
import gsap from "gsap";
import ScaleManager from "@/stage/ScaleManager";

export default class RewardContainer extends BaseContainer {
  constructor(data) {
    super(data)

    this.init(data)
    this.maxRewards = 3 // Max rewards in the row
  }

  init(data) {
    this.name = 'RewardContainer'

    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.showfreebets.add(this.onShowfreebets, this)
    Signals.makeBets.add(this.onMakeBets, this)

    this.stack = []

    // Just to check if you want
    // setInterval(() => this.onShowfreebets(1), 6000)
  }

  onAnimationComplete(reward) {
    if (reward.toRemove)
      this.hideReward(reward)
    else
      this.completeReward(reward)
  }

  createReward() {
    const reward = new SpineAnimation('reward')
    const listener = {complete: () => this.onAnimationComplete(reward)}
    reward.state.addListener(listener)
    reward.y = 183
    reward.visible = false

    reward.toRemove = (this.stack.length >= this.maxRewards)

    this.stack.push(reward)
    this.addChild(reward)

    return this
  }

  playReward(animName) {
    const reward = this.currentReward
    reward.visible = true
    reward.start([animName], [false])

    reward.staticAnimation = animName === 'freebet' ? 'freeBetStatic' : 'bonusStatic'

    Facade.soundManager.play('jet2_game_reward', 0.5)
    Facade.soundManager.play('jet2_VO_Reward', 0.4)
  }

  completeReward() {
    const reward = this.currentReward
    const newPosition = {
      x: ScaleManager.currentSizes.total.width / 3.8,
      y: (ScaleManager.currentSizes.total.height / 6) - this.stack.length * 70,
    }

    const newScale = {
      x: 0.20, y: 0.20,
    }

    const onComplete = {
      onComplete: () => {
        reward.start([reward.staticAnimation], [false])
      }
    }

    gsap.to(reward, 2, newPosition)
    gsap.to(reward.scale, 2, {
      ...newScale,
      ...onComplete,
    })
  }

  hideReward() {
    let reward = this.stack.pop()
    if (reward) {
      gsap.to(reward, 2, {
        alpha: 0,
        onComplete: () => {
          reward.parent.removeChild(reward)
          reward = null
        }
      })
    }
  }

  clearRewards() {
    this.stack.forEach(reward => reward.parent.removeChild(reward))
    this.stack.length = 0
  }

  get currentReward() {
    return this.stack[this.stack.length - 1]
  }

  onMakeBets() {
    this.clearRewards()
  }

  onShowfreebets(value) {
    if (value)
      this.createReward().playReward('freebet')
  }

  onStopFeature(currentBonus) {
    if (currentBonus && currentBonus.tp === 'multiplier' && currentBonus.v > 1)
      this.createReward().playReward('bonus')
  }
}
